/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
(function () {
  // Hero Section Script Start
  $(".hero-slider").slick({
    dots: true,
    infinite: true,
    fade: true,
    arrows: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  // Hero Section Script End
  // Product Slider Script Start
  $(".product-slider").slick({
    dots: true,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // Product Slider Script End

  // Featured Collection Script Start
  $(".cfc-pdp-slider").slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // Featured Collection Script End

  // Product Gallery Script Start
  $(".pdp-slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".pdp-slider-nav",
  });
  $(".pdp-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".pdp-slider-for",
    dots: false,
    centerMode: false,
    vertical: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          vertical: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
  // Product Gallery Script End
  // Product Detail Page Varint as a dropdowown script start
  $(document).ready(function () {
    $("#custom-collaspe-btn").on("click", function () {
      $("#ymq-box").toggle(1000);
    });
    const variants = $("[name='options[Color]']");
    if (variants.length > 0) {
      variants.each(function() {
        $(this).on('change', () => {
          const currentVariant = $(this);
          const colorLegend = $('#currentColorSwatch');
          if(colorLegend) {
            colorLegend.text(currentVariant.val())
          }
          const variantSliderImages = document.querySelectorAll('div.variant-image');
          if(variantSliderImages) {
            variantSliderImages.forEach((image) => {
              if(!image.classList.contains('hidden')) {
                image.classList.add('hidden');
              }
              if(image.dataset.variant === currentVariant.val()) {
                image.classList.remove('hidden');
              }
            });
          }
          const mediaPosition = currentVariant.attr('data-media-position');
          const matchingDiv = $('.pdp-slider-for .slick-slide').find(`div[data-position='${mediaPosition}']`);
          if(matchingDiv.length > 0) {
            const slideIndex = matchingDiv.closest('.slick-slide').data('slick-index');
            $('.pdp-slider-for').slick('slickGoTo', slideIndex);
          }
        });
      });
    }
  });
  // Product Detail Page Varint as a dropdowown script end

  // Product Tabs Script Start
  document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".sfyn-pdp-tabs-wrapper li a");
    const tabItems = document.querySelectorAll(".sfyn-tab-item");

    tabButtons.forEach(function (tabButton) {
      tabButton.addEventListener("click", function (e) {
        e.preventDefault();
        tabButtons.forEach(function (button) {
          button.classList.remove("sfyn-active-tab-btn");
        });
        tabButton.classList.add("sfyn-active-tab-btn");

        const target = tabButton.getAttribute("data-url");
        tabItems.forEach(function (tabItem) {
          if (tabItem.getAttribute("data-url-target") === target) {
            tabItem.style.display = "block";
          } else {
            tabItem.style.display = "none";
          }
        });
      });
    });

    if (tabButtons.length > 0) {
      tabButtons[0].click();
    }
  });
  // Product Tabs Script End
  // Accordion Script Start
  $(document).ready(function () {
    // Add click event to elements with class "sfyn-ac-title"
    $(".sfyn-ac-title").on("click", function () {
      // Toggle the new class on the parent element with class "sfyn-ac-item"
      $(this).parent(".sfyn-ac-item").toggleClass("sfyn-active-ac-item");

      // Toggle the visibility of the associated content
      $(this).next(".sfyn-ac-body").slideToggle();

      // Hide content and remove class from other items
      $(".sfyn-ac-title").not(this).next(".sfyn-ac-body").slideUp();
      $(".sfyn-ac-item")
        .not($(this).parent(".sfyn-ac-item"))
        .removeClass("sfyn-active-ac-item");
    });
    $(".sfyn-ac-item:first-child .sfyn-ac-body").slideDown();
    $(".sfyn-ac-item:first-child").addClass("sfyn-active-ac-item");
  });
  // Accordion Script end
  const addToCartBtn = document.querySelector('.add-to-cart-button');
  if(addToCartBtn) {
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent page refresh

      var productId = document.querySelector('input[name="id"]').value; // The product variant ID

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          updateCartCount(); // Update the cart count after adding to cart
        });
    });
    // Function to update the cart count
    function updateCartCount() {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const cartCount = cart.item_count;
          document.querySelector(".mycart-quantity").textContent = cartCount; // Update the cart count in the DOM
        });
    }
  }
})();
